module.exports = __webpack_public_path__ + "static/media/інпрофіт-модернізація-систем-обробки-зерна.34642d1e.jpg";